import { render, staticRenderFns } from "./XYJingMu.vue?vue&type=template&id=6e22dcad&scoped=true"
import script from "./XYJingMu.vue?vue&type=script&lang=js"
export * from "./XYJingMu.vue?vue&type=script&lang=js"
import style0 from "./XYJingMu.vue?vue&type=style&index=0&id=6e22dcad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22dcad",
  null
  
)

export default component.exports